/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import DocumentsPage from '../../pages/contractor/DocumentsPage/DocumentsPage';
import FileUploadPage from '../../pages/contractor/FileUploadPage/FileUploadPage';
import GetStartedPage from '../../pages/contractor/GetStartedPage/GetStartedPage';
import LaborInformationPage from '../../pages/contractor/LaborInformationPage/LaborInformationPage';
import RegistrationCompletionPage from '../../pages/contractor/RegistrationCompletionPage/RegistrationCompletionPage';
import WelcomePage from '../../pages/contractor/WelcomePage/WelcomePage';
import YourCompanyPage from '../../pages/contractor/YourCompanyPage/YourCompanyPage';

export default function ContractorNavigation(): ReactElement {
    return (
        <Routes>
            <Route path='welcome' element={<WelcomePage />} />
            <Route path='getStarted' element={<GetStartedPage />} />
            <Route path='company' element={<YourCompanyPage />} />
            <Route path='laborInfo' element={<LaborInformationPage />} />
            <Route path='documents' element={<DocumentsPage />} />
            <Route
                path='upload/:fileName/:label'
                element={<FileUploadPage />}
            />
            <Route path='complete' element={<RegistrationCompletionPage />} />
            <Route path='*' element={<Navigate to='welcome' replace />} />
        </Routes>
    );
}
